import { readBool } from 'utils/readBool';
import { useKitTranslate } from 'common/components/kit-shared/useKitTranslate';

export const useMyAssembliesLabel = (): string => {
  const t = useKitTranslate();
  return t(readBool('variables.showManageKits')
    ? 'texts.kits.myAssemblies'
    : 'texts.kits.myAssembliesLegacy');
};

export default useMyAssembliesLabel;
